import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent,
  List,
  ListItem,
  Divider,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import image1 from "../Images/image.jpg"
import image2 from "../Images/DSC03948.webp"
import image3 from "../Images/generated_image_2.png"
import image4 from "../Images/DSC03947.webp"
import image5 from "../Images/DSC04019.JPG"
import image6 from "../Images/DSC04014.JPG"
import image7 from "../Images/generated_image_6.png"
import image8 from "../Images/generated_image_7.png"
export default function WellnessInfoPage() {
  return (
    <Box sx={{ backgroundColor: "#f9fafb", color: "black", pb: 8, pt: 10 }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: "linear-gradient(to right, #0077b6, #00b4d8)",
          color: "#fff",
          py: { xs: 6, md: 10 },
          textAlign: "center",
        
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Typography variant="h2" fontWeight={700} gutterBottom>
          THE GREAT HIMALAYAS
        </Typography>
        <Typography variant="h5" fontWeight={500} gutterBottom>
          Premium Wellness Retreat & Digital Detox Programs
        </Typography>
      </Box>

      <Container maxWidth="lg" sx={{ mt: 6 }}>
         <Box sx={{ mb: 4, textAlign: 'center' }}>
 <img 
  src={image1} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 700, borderRadius: 8, objectFit: 'cover' }}
/>

  </Box>
        {/* About Section */}
        <Typography variant="h5" fontWeight={600} gutterBottom>
          <span role="img" aria-label="mountain">
          </span>{" "}
          ESCAPE TO TRANSFORMATION
        </Typography>
        <Typography fontWeight={600} gutterBottom>
          Discover Authentic Himalayan Wellness in Sikkim & Darjeeling
        </Typography>

        <Typography paragraph>
          Welcome to The Great Himalayas - your trusted partner for delivering
          transformational wellness experiences in the pristine Eastern
          Himalayas. We specialize in curating and executing end-to-end wellness
          programs that combine ancient healing traditions, natural immersion,
          and modern hospitality.
        </Typography>

        <Typography marginTop={1}>
          <b>
            This broucher showcases our comprehensive capabilities as a preferred
            logistics and operations partner for wellness retreat organizers,
            yoga schools, corporate wellness programs, and digital detox
            specialists.
          </b>
        </Typography>

        {/* Why Partner Section */}
        <Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
          WHY PARTNER WITH THE GREAT HIMALAYAS?
        </Typography>
        <List dense>
          {[
            "Regional Expertise - 10+ years combined experience in Northeast India tourism and wellness operations",
            "Local Infrastructure - Established network of 50+ vetted accommodation partners, guides, and wellness practitioners",
            "Logistics Excellence - Professional fleet management, experienced drivers, and 24/7 support",
            "Quality Assurance - Rigorous vetting, pre-program inspections, and continuous quality monitoring",
            "Cost Efficiency - Leverage vendor relationships for preferential pricing and bulk discounts",
            "Seamless Coordination - From ground transport to on-ground support, everything handled professionally",
            "Guest Satisfaction - Dedicated coordinators ensure exceptional participant experiences",
          ].map((item, idx) => (
            <ListItem
              key={idx}
              sx={{ pl: 0, mb: 1, fontWeight: 500, fontSize: "1rem" }}
            >
              ✓ {item}
            </ListItem>
          ))}
        </List>

        {/* Core Wellness Offerings */}
        <Typography variant="h5" fontWeight={600} sx={{ mt: 8, mb: 4 }}>
          OUR CORE WELLNESS OFFERINGS
        </Typography>

        {/* Wellness Offering Cards */}
        <Grid container spacing={4}>
          {/* Digital Detox Program */}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
             
              <CardContent>
                          <img 
  src={image5} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover', marginBottom: '6px' }}
/>
                <Typography variant="h6" fontWeight={600}>
                  1. DIGITAL DETOX PROGRAMS
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Unplug. Reconnect. Transform.
                </Typography>
                <Typography sx={{ mt: 1, mb: 2 }}>
                  Complete digital disconnection in nature-based settings with
                  structured wellness activities.
                </Typography>
                <Typography>
                  <b>Program Features:</b> - Complete technology-free
                  environment (phones stored, no WiFi in activity areas) - Daily
                  guided meditation and mindfulness sessions (6:00 AM - 7:00 AM)
                  - Forest bathing and nature immersion walks (therapeutic
                  forest therapy) - Yoga asana practice tailored to detox and
                  stress relief - Creative expression workshops (art,
                  journaling, music) - Group bonfire circles with storytelling
                  and connection - Sound baths and silence sessions for deep
                  relaxation - Nutritional counseling and organic meals - Sleep
                  optimization coaching and evening relaxation protocols
                </Typography>
                <Typography marginTop={1}>
                  <b>Benefits:</b>- Reduced anxiety and stress by average 60%
                  (post-program surveys) - Improved sleep quality and circadian
                  rhythm restoration - Enhanced mental clarity and focus -
                  Stronger social connections and authentic relationships -
                  Renewed appreciation for nature and simple living - Lasting
                  behavior change reducing screen time
                </Typography>
                <Typography marginTop={1}>
                  <b>Typical Duration:</b>3 days (weekend), 5 days (mid-week), 7
                  days (extended)
                </Typography>
                <Typography>
                  <b>Group Size:</b>8-20 participants ideal, scalable to 50+
                </Typography>
                <Typography>
                  <b>Typical Duration:</b> Spring (March-May), Autumn
                  (September-November)
                </Typography>

                <Typography marginTop={1}>
                  <b>Partner Benefits</b> - Premium positioning in your
                  portfolio - High satisfaction rates (4.8/5 average rating) -
                  Strong repeat booking rate (40% returnees) - Ideal for
                  corporate stress management programs
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Himalayan Yoga Retreats */}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
             
              <CardContent>
                 <img 
  src={image2} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover',  marginBottom: '6px' }}
/>
                <Typography variant="h6" fontWeight={600}>
                  2. HIMALAYAN YOGA RETREATS
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Classical Yoga Practices in Ancient Mountain Settings
                </Typography>
                <Typography marginTop={1}>
                  Traditional and modern yoga programs aligned with your
                  teaching methodology.
                </Typography>
                <Typography marginTop={1}>
                  <b>Program Components:</b> - Daily yoga asana practice
                  (beginner-friendly to advanced options available) - Pranayama
                  (breath work) sessions for energy optimization - Meditation
                  and mindfulness training - Yoga philosophy and lifestyle
                  coaching - Chakra balancing and energy work - Partner yoga and
                  group asana classes - Sunrise and sunset practice sessions on
                  scenic platforms - Yoga nidra (guided deep relaxation) -
                  Kirtan and chanting circles
                </Typography>
                <Typography marginTop={1}>
                  <b>Specialized Formats Available:</b>- Teacher Training
                  Retreats - Intensive TTC preparation/refresher programs -
                  Alignment-Focused Retreats - Precision alignment and injury
                  prevention - Vinyasa Flow Intensive - Dynamic flow and power
                  yoga - Yin Yoga & Restorative - Passive stretching and deep
                  relaxation - Prenatal & Postnatal Yoga - Specialized women's
                  wellness - Senior Yoga & Gentle Practice - Adapted for 55+
                  participants
                </Typography>
                <Typography marginTop={1}>
                  <b>Facilities:</b>- Dedicated yoga pavilion with
                  ocean/mountain views - Matted platform with wind protection -
                  Acoustic excellence for sound bathing - Natural ventilation
                  and temperature control - Props and equipment fully provided
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - Authentic Himalayan setting
                  enhances practice depth - Experienced yoga facilitators
                  available for co-teaching - Perfect conditioning for teacher
                  training students - High-quality accommodation supports
                  recovery
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/* Meditation & mindfulness retreats*/}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
            
              <CardContent>
                <Typography variant="h6" fontWeight={600}>
                  3. MEDITATION & MINDFULNESS RETREATS
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Deep Inner Transformation Through Contemplative Practice
                </Typography>
                <Typography marginTop={1}>
                  Silent and non-silent meditation programs tailored to skill
                  levels:
                </Typography>
                <Typography marginTop={1}>
                  <b>Meditation Offerings:</b>- Vipassana Meditation - Insight
                  meditation intensive (3, 7, 10 day formats) - Mindfulness
                  Meditation - MBSR-aligned contemporary mindfulness -
                  Loving-Kindness (Metta) - Compassion cultivation practices -
                  Zen Meditation - Zazen practice and Zen teachings - Osho
                  Active Meditations - Dynamic and expressive practices - Chakra
                  Meditation - Energy center balancing - Nature-Based Meditation
                  - Mindfulness in natural settings - Breathwork Meditation -
                  Advanced pranayama-meditation integration
                </Typography>
                <Typography marginTop={1}>
                  <b>Daily Schedule Example:</b> - 5:30 AM: Bell & awakening tea
                  - 6:00-7:00 AM: Guided meditation - 7:00-8:00 AM:
                  Yoga/movement (optional) - 8:00-9:30 AM: Organic breakfast -
                  9:30 AM-12:30 PM: Teaching session & practice - 12:30-2:00 PM:
                  Lunch & rest - 2:00-5:00 PM: Individual practice/nature time -
                  5:00-6:30 PM: Group meditation - 6:30-7:30 PM: Dinner -
                  7:30-8:30 PM: Satsang/teachings/silence
                </Typography>
                <Typography marginTop={1}>
                  <b>Ideal For:</b> - Beginner meditators seeking foundation -
                  Experienced practitioners deepening practice - Trauma recovery
                  and stress management - Corporate mindfulness programs -
                  Spiritual seekers and pilgrimages
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - Silent retreat infrastructure ready
                  - Multi-lineage meditation support available - Excellent
                  retention and repeat business - Strong referral networks in
                  meditation communities
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/* Ayurveda & wellness healing*/}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
             
              <CardContent>
                <Typography variant="h6" fontWeight={600}>
                  4. AYURVEDA & WELLNESS HEALING
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Ancient Science of Health Restoration
                </Typography>
                <Typography marginTop={1}>
                  Comprehensive Ayurvedic wellness programs combining diagnosis,
                  treatment, and lifestyle education:
                </Typography>
                <Typography marginTop={1}>
                  <b>Ayurvedic Services:</b> - Initial Dosha consultation and
                  constitutional analysis - Personalized Ayurvedic diet and
                  nutrition planning - Herbal remedies and supplement protocols
                  - Panchakarma (5-action deep cleansing) programs - Abhyanga
                  (full-body oil massage) therapy - Shirodhara (oil stream
                  therapy) for relaxation - Nasya (nasal therapy) for clarity -
                  Basti (therapeutic enema) for toxin removal - Herbal steam
                  treatments and body wraps - Pulse reading and Ayurvedic
                  diagnostics - Yoga & meditation aligned with Ayurvedic
                  principles
                </Typography>
                <Typography marginTop={1}>
                  <b>Specialty Programs:</b> - Detox & Cleansing (7-14 days) -
                  Deep system purification - Rejuvenation (10-14 days) -
                  Anti-aging and vitality restoration - Stress Relief (5-7 days)
                  - Nervous system balancing - Sleep Optimization (5-7 days) -
                  Insomnia and sleep disorders - Digestive Health (7 days) - GI
                  restoration and metabolism - Weight Management (14-21 days) -
                  Healthy weight loss - Arthritis & Joint Care (10-14 days) -
                  Inflammation reduction
                </Typography>
                <Typography marginTop={1}>
                  <b>Practitioners:</b>- BAMS-certified Ayurvedic doctors
                  (Bachelor of Ayurvedic Medicine & Surgery) - Experienced
                  massage therapists - Nutritionists with Ayurvedic training -
                  Wellness coordinators
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - Differentiates your offerings with
                  medical-grade wellness - Strong therapeutic outcomes (75%
                  health improvement) - Attracts health-conscious and older
                  demographics - Recurring wellness business and referrals
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/* Ayurveda & wellness healing*/}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
          
              <CardContent>
                        
                 <img 
  src={image4} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover',  marginBottom: '6px' }}
/>
                <Typography variant="h6" fontWeight={600}>
                  5. NATURE IMMERSION & ECO-WELLNESS
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Heal Through Connection with Earth & Living Systems
                </Typography>
                <Typography marginTop={1}>
                  Nature-based therapy programs combining ecotherapy, forest
                  bathing, and environmental connection:
                </Typography>
                <Typography marginTop={1}>
                  <b>Nature Activities:</b>- Forest Bathing (Shinrin-Yoku) -
                  Guided sensory immersion in forest - Guided Nature Walks -
                  Trail exploration with naturalist guides - Trekking
                  Experiences - Easy to moderate multi-day treks - Bird Watching
                  & Wildlife Observation - Nature photography sessions - Sacred
                  Site Visits - Spiritual and cultural heritage tours -
                  Waterfall & Stream Immersion - Natural hydrotherapy -
                  Stargazing Sessions - Astronomy and celestial meditation -
                  Photography in Nature - Creative expression through images -
                  Sustainability Education - Eco-consciousness workshops -
                  Community Service - Local environmental projects
                </Typography>
                <Typography marginTop={1}>
                  <b>Featured Locations:</b>- Gangtok Region - Rhododendron
                  forests, city nature escapes - Pelling - Kanyam tea gardens,
                  forest treks, valley views - Kanyam - Organic farms,
                  Darjeeling tea plantations - Lachung Valley - Alpine meadows,
                  pristine natural beauty - Yuksom - Gateway to Kinchingjunga
                  trek, ancient monasteries - Kalimpong - Colonial hill station,
                  organic farms - Teesta River - River therapy and aquatic
                  immersion
                </Typography>
                <Typography marginTop={1}>
                  <b>Environmental Impact:</b> - 1 tree planted per participant
                  in reforestation project - Plastic-free programs with minimal
                  environmental footprint - Support for local conservation
                  initiatives - Carbon offset included in all packages
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - Sustainability-focused programs
                  attract environmentally conscious groups - Differentiates from
                  standard tourist packages - Supports conservation and
                  community development - Aligns with corporate ESG initiatives
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/*corporate wellness retreats*/}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
   
              <CardContent>
                                <img 
  src={image6} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover',  marginBottom: '6px' }}
/>
                <Typography variant="h6" fontWeight={600}>
                  6. CORPORATE WELLNESS RETREATS
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Executive Stress Management & Team Building in Nature
                </Typography>
                <Typography marginTop={1}>
                  Comprehensive corporate wellness programs designed for
                  organizational health:
                </Typography>
                <Typography marginTop={1}>
                  <b>Executive Retreat</b>(2-3 days) - Stress management for
                  C-suite - Work-life balance coaching - Nature immersion for
                  recovery - Meditation and breathing techniques - Luxury
                  accommodation and premium dining
                </Typography>
                <Typography marginTop={1}>
                  <b>Team Building & Wellness </b>(3-5 days) - Team yoga and
                  group fitness - Cooperative nature activities - Leadership
                  through outdoor challenges - Group meditation and mindfulness
                  - Bonfire and team bonding circles - Healthy organic meals and
                  wellness coaching
                </Typography>
                <Typography marginTop={1}>
                  <b>Employee Wellness Program</b>(5-7 days) - Comprehensive
                  wellness assessment - Personalized fitness and yoga plans -
                  Stress management training - Nutrition and lifestyle coaching
                  - Preventative health education - Buddy support and peer
                  mentoring
                </Typography>
                <Typography marginTop={1}>
                  <b>Annual Wellness Retreat</b> (2-3 days, recurring) -
                  Wellness resets for teams - Health screening and monitoring -
                  Skill-building workshops - Nature-based team events -
                  Recognition and celebration
                </Typography>

                <Typography marginTop={1}>
                  <b>Health Outcomes:</b> - Average stress reduction: 55% -
                  Sleep improvement: 72% of participants - Energy level
                  increase: 64% - Team cohesion improvement: 81% - Post-retreat
                  productivity boost sustained 3+ months
                </Typography>
                <Typography marginTop={1}>
                  <b>Corporate Packages Include:</b>- Pre-retreat wellness
                  assessment questionnaires - Customized program design per
                  organizational needs - Professional facilitators and wellness
                  experts - Luxury accommodation and organic meals -
                  Transportation coordination - Post-retreat wellness report and
                  recommendations - 30-day follow-up support program
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - High-ticket corporate programs
                  (₹3-5L per group) - Recurring annual business - Large group
                  logistics (50-200+ participants) - Strong reputation
                  enhancement through corporate endorsements
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/*transformational wellness intensives*/}
          <Grid item xs={12} md={12}>
            <Card elevation={3}>
             
              <CardContent>
                <Typography variant="h6" fontWeight={600}>
                  7. TRANSFORMATIONAL WELLNESS INTENSIVES
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Specialized Multi-Day Deep Work Programs
                </Typography>
                <Typography marginTop={1}>
                  Intensive programs combining multiple modalities for profound
                  transformation:
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: 600 }}>
                  Signature Intensive Programs:
                </Typography>
                <Typography marginTop={1}>
                  <b>7-Day Renewal & Reset</b>(Most Popular) - Comprehensive
                  digital detox experience - Daily yoga and meditation practice
                  - Ayurvedic treatments and organic nutrition - Nature
                  immersion and forest bathing - Wellness education and
                  lifestyle coaching - Transformational group ceremonies
                </Typography>
                <Typography marginTop={1}>
                  <b>10-Day Yoga & Meditation Intensive</b> (Teacher Training
                  Focused) - 200-hour teacher training preparation - Advanced
                  asana, pranayama, and meditation - Yoga philosophy and
                  Bhagavad Gita study - Teaching methodology and practice -
                  Intensive peer learning
                </Typography>
                <Typography marginTop={1}>
                  <b>14-Day Holistic Wellness & Healing</b> - Complete
                  Panchakarma Ayurvedic cleansing - Deep meditation practice -
                  Therapeutic yoga - Nutritional reset and detox - Lifestyle
                  transformation coaching - Extended nature immersion
                </Typography>
              
                <Typography marginTop={1}>
                  <b>21-Day Complete Transformation</b>- Extended Ayurvedic healing program - Advanced yoga and meditation practices - Spiritual teachings and philosophy - Personal counseling and life coaching - Community service engagement - Integration ceremony and completion celebration
                </Typography>
                  <Typography marginTop={1}>
                  <b>Transformation Outcomes:</b> - 85% report life-changing experience - 70% maintain practices 6+ months post-retreat - Average weight loss: 3-5 kg (sustainable) - Anxiety reduction: 60-75% - Sleep quality improvement: 72%
                </Typography>
                <Typography marginTop={1}>
                  <b>Partner Benefits:</b> - Premium pricing justification through results - High satisfaction scores driving referrals - Exclusive positioning in premium market - Strong testimonials and media coverage potential
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Add other offerings similarly... */}
        </Grid>

        <Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
          ACCOMMODATION & FACILITIES
        </Typography>
               <img 
  src={image7} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover',  marginBottom: '6px' }}
/>

 <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
          Curated Property Selection
        </Typography>
        <Typography>We partner with carefully vetted accommodation providers offering:</Typography>
        <Typography sx={{ mt: 1}}><b>Luxury Resorts</b> (5-star facilities) - High-end room amenities and furnishings - Multi-cuisine dining with international options - Full-service spa and wellness centers - Conference facilities for corporate programs - ₹5,000-10,000 per night per room</Typography>
        <Typography sx={{ mt: 1}}><b>Wellness-Specific Retreats</b> (Specialized centers) - Purpose-built retreat infrastructure - Dedicated yoga halls and meditation spaces - Ayurvedic treatment rooms - Organic farm-to-table kitchens - Community spaces for group activities - ₹3,000-7,000 per night per room</Typography>
        <Typography sx={{ mt: 1}}><b>Boutique Properties</b> (Intimate settings) - 10-30 room capacity for exclusive retreats - Personalized service and attention - Authentic local design and hospitality - Often family-run with personal touch - ₹2,500-5,000 per night per room</Typography>
        <Typography sx={{ mt: 1}} ><b>Nature Retreat Centers</b> (Eco-facilities) - Jungle or forest settings - Minimal environmental footprint - Basic to moderate comfort amenities - Authentic nature immersion experience - ₹1,500-3,500 per night per room</Typography>
<Typography sx={{ mt: 1}}><b>Room Amenities (Typical):</b> - Private bathrooms with hot water - Comfortable bedding and pillows - Mountain or garden views - Sustainable/eco-friendly products - WiFi (optional for digital detox programs) - Climate control as needed - Room service and hospitality</Typography>
<Typography sx={{ mt: 1}}><b>Shared Facilities:</b> - Yoga hall/meditation space - Dining areas with healthy menu - Living rooms and gathering spaces - Nature trails on property - Organic gardens - Library and quiet spaces</Typography>
<Typography sx={{ mt: 1}}><b>Food & Nutrition:</b> - Organic, locally-sourced ingredients - Vegetarian and vegan options standard - Special dietary accommodations - Ayurvedic meal planning available - Herbal teas and wellness beverages - Farm-to-table farm visits included</Typography>

<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
         TRANSPORTATION & LOGISTICS
        </Typography>
               <img 
  src={image8} 
  alt="Himalayan Landscape" 
  style={{ width: '100%', height: 'auto', maxHeight: 400, borderRadius: 8, objectFit: 'cover',  marginBottom: '6px' }}
/>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         Professional Fleet & Services
        </Typography>
        <Typography sx={{ mt: 1}}><b>Vehicle Fleet:</b> - Sedans (4-seater) for couples/small groups - SUVs (7-seater) for family groups - Tempo Travellers (12-16 seater) for larger groups - Mini buses (25-30 seater) for bulk transportation - All vehicles regularly maintained and insured</Typography>
        <Typography sx={{ mt: 1}}><b>Driver Standards:</b> - Commercial driving licenses with safety records - 5+ years regional driving experience - Professional training in hospitality service - GPS navigation and local expertise - Fluent in English and regional languages - Emergency first aid certified</Typography>
        <Typography sx={{ mt: 1}}><b>Transportation Included:</b> - Airport/Railway pickups from Bagdogra (IXB), NJP - Inter-city transfers (Siliguri to Gangtok, Darjeeling, etc.) - Daily activity transportation - Local exploration and sightseeing - Emergency medical transportation if needed - 24/7 vehicle support and contingency</Typography>
        <Typography sx={{ mt: 1}}><b>Journey Features:</b> - Comfortable seating with safety features - Climate-controlled interiors - Scenic route expertise for photo opportunities - Flexibility for stops and photo sessions - Professional, courteous service throughout</Typography>


<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
     EXPERT FACILITATION TEAM
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         Wellness Practitioners & Guides
        </Typography>
                <Typography>We coordinate with pre-vetted specialists available for your programs:</Typography>
                <Typography sx={{ mt: 1}}><b>Yoga Teachers</b> - RYT 200-500 hour certified instructors - Specialization: Hatha, Vinyasa, Kundalini, Yin, Restorative, etc. - Teaching experience: 5-15+ years - Multilingual English, Hindi, regional languages</Typography>
                <Typography sx={{ mt: 1}}><b>Meditation Facilitators</b> - Vipassana, Mindfulness, and Zen meditation trained - Trauma-informed facilitators for healing work - Experienced with various meditation lineages - Retreat facilitation expertise</Typography>
                <Typography sx={{ mt: 1}}><b>Ayurvedic Practitioners</b> - BAMS-certified Ayurvedic doctors - Panchakarma therapy specialists - 10+ years clinical experience - Consultation, diagnosis, and treatment planning</Typography>
                <Typography sx={{ mt: 1}}><b>Massage & Wellness Therapists</b> - Abhyanga, Shirodhara, and specialized massage trained - Spa and wellness center management experience - Personalized treatment planning - First aid and safety protocols</Typography>
                <Typography sx={{ mt: 1}}><b>Naturalist Guides</b> - Forest and wildlife knowledge - Local history and cultural expertise - Trekking and outdoor safety certification - Environmental education and interpretation</Typography>
                <Typography sx={{ mt: 1}}><b>Nutritionists & Health Coaches</b> - Ayurvedic nutrition specialists - Wellness and lifestyle coaching - Dietary planning and education - Corporate wellness program facilitators</Typography>
                <Typography sx={{ mt: 1}}><b>Support Coordinators</b> - Retreat operations and logistics management - Participant care and customer service - Emergency response and crisis management - Photography and content documentation</Typography>


<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
 WHY PARTICIPANTS CHOOSE THE GREAT HIMALAYAS
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         Participant Testimonials & Outcomes
        </Typography>
        <Typography sx={{ mt: 1}}><b>"Life-Changing Experience"</b> - <b>Digital Detox Program</b> "Arriving exhausted from constant screen time, I left completely transformed. The digital detox combined with yoga and meditation helped me reset my entire relationship with technology. I'm still maintaining the habits 6 months later!" - Sarah M., UK</Typography>
        <Typography sx={{ mt: 1}}><b>"Best Corporate Retreat Ever"</b> - <b>Executive Wellness</b> "Our team left stressed and disconnected. The 3-day retreat in nature, combined with yoga, meditation, and authentic facilitators, brought our team closer than ever. We've already booked for next year!" - Rajesh K., Mumbai Tech Company</Typography>
        <Typography sx={{ mt: 1}}><b>"Ayurveda Healing"</b> - <b>Wellness & Healing</b> "I came with chronic digestive issues and insomnia. After the 7-day Ayurvedic program, my digestion normalized and I sleep through the night for the first time in years. The personalized care and expert practitioners made all the difference." - Jennifer P., USA</Typography>
        <Typography sx={{ mt: 1}}><b>"Yoga Intensive Excellence"</b> - <b>Teacher Training Retreat</b> "Perfect for deepening my practice before TTC. The combination of quality instruction, serene setting, and supportive community created the ideal environment for intensive learning." - Michael R., Australia</Typography>


<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
     SPECIAL OFFERINGS FOR WELLNESS PARTNERS
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         Partnership-Exclusive Benefits
        </Typography>
        <Typography>When you partner with The Great Himalayas, your programs include:</Typography>
          <Typography sx={{ mt: 1}}><b>Customization & Flexibility</b> - Tailored program design to your specifications - Accommodation and facility selection per your preferences - Facilitator coordination matching your teaching style - Flexible scheduling and last-minute adjustments - Co-facilitation options if desired</Typography>
          <Typography sx={{ mt: 1}}><b>Cost Efficiency</b> - Preferred vendor pricing (10-20% savings vs. direct booking) - Bulk discounts for multiple programs - Seasonal rate optimization - Transparent pricing with no hidden fees - Volume-based partnership pricing tiers</Typography>     
          <Typography sx={{ mt: 1}}><b>Marketing Support</b> - Photography and videography of your programs - Digital content for social media and websites - Testimonial collection and case studies - Co-branded marketing materials - Featured placement on thegreathimalayas.com</Typography>
          <Typography sx={{ mt: 1}}><b>Participant Experience Excellence</b> - Pre-program welcome packets with logistics info - Dedicated on-ground coordinators - Participant care and satisfaction prioritized - Post-program feedback collection - Complimentary group photo sessions</Typography>
          <Typography sx={{ mt: 1}}><b>Quality Assurance</b> - Pre-program site inspections - Property and vendor vetting - Contingency planning for emergencies - Post-program debrief and recommendations - Continuous improvement protocols</Typography>
          <Typography sx={{ mt: 1}}><b>Unique Advantages</b> - Access to pristine Himalayan settings unavailable elsewhere - Regional expertise impossible to replicate - Established vendor relationships and local credibility - Professional infrastructure reducing operational stress - Proven track record of participant satisfaction</Typography>


<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
     MEASURABLE SUCCESS METRICS
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         Proven Results
        </Typography>
         <Typography sx={{ mt: 1}}><b>Participant Satisfaction</b> - Average rating: 4.8/5 stars - Return/recommend rate: 78% - Program completion rate: 96% - Testimonial requests: 65% of participants</Typography>
          <Typography sx={{ mt: 1}}><b>Wellness Outcomes (Post-Program Survey, 30 days)</b> - Stress reduction: 60% average decrease - Sleep quality improvement: 72% report better sleep - Energy level increase: 64% feel more energized - Weight loss (wellness programs): 3-5 kg sustainable loss - Anxiety reduction: 58% report lower anxiety</Typography>
           <Typography sx={{ mt: 1}}><b>Long-Term Behavior Change (3-month follow-up)</b> - Meditation practice continued: 68% - Yoga practice continued: 72% - Dietary changes maintained: 55% - Wellness improvements sustained: 82% - Referral rate: 45% recommend to friends/family</Typography>
            <Typography sx={{ mt: 1}}><b>Corporate Outcomes (Team-based programs)</b> - Team cohesion improvement: 81% - Stress reduction: 55% average across team - Post-retreat productivity: Sustained 3+ months - Absenteeism reduction: 15% decrease next month - Team satisfaction with retreat: 92%</Typography>
             <Typography sx={{ mt: 1}}><b>Business Metrics for Partners</b> - Program booking completion rate: 96% - Average participant satisfaction: 4.8/5 - Repeat booking rate: 40% book again within 18 months - Referral rate: 45% recommend - Average group size: 18-22 participants per program</Typography>


<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
     FEATURED DESTINATIONS
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         The Himalayan Canvas
        </Typography>
        <Typography sx={{ mt: 1}}><b>Sikkim - "The Land of Beauty"</b> - Gangtok - Modern hill station with spiritual essence - Pelling - Nestled among tea gardens and mountains - Lachung Valley - Alpine meadows and pristine nature - Yuksom - Gateway to Kinchingjunga, ancient culture - Kanyam - Organic farms and traditional living</Typography>
        <Typography sx={{ mt: 1}}><b>Darjeeling - "The Queen of Hills"</b> - Darjeeling Town - Historic hill station with wellness infrastructure - Kalimpong - Colonial charm with organic orchards - Tiger Hill - Sunrise vistas and meditation platforms - Mirik - Lake and forest immersion - Kurseong - Tea plantations and hill walks</Typography>
        <Typography sx={{ mt: 1}}><b>North Bengal</b> - Siliguri - Gateway hub with modern facilities - Dooars - Jungle region with wildlife and nature - Jalpaiguri - Forest and river immersion - Gorumara National Park - Wildlife and eco-tourism</Typography>
        <Typography sx={{ mt: 1}}><b>Climate & Best Seasons</b> - <b>Spring (March-May)</b> - Rhododendron blooms, perfect weather, 15-25°C - <b>Summer (June-August)</b> - Lush greenery, monsoon mystique, 18-28°C - <b>Autumn (September-November)</b> - Clear skies, ideal temperatures, 12-22°C - <b>Winter (December-February)</b> - Crisp air, snow on peaks, 5-15°C</Typography>

<Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
     CONTACT INFORMATION?
        </Typography>
<Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 2 }}>
         The Great Himalayas
        </Typography>
<Typography>(A Brand of HimalayanZenith Ventures Private Limited)</Typography>
 <Typography sx={{ mt: 1}}><b>Email:</b> contact@thegreathimalayas.com</Typography>
  <Typography ><b>Phone/WhatsApp:</b>+91 9883587965</Typography>
   <Typography ><b>Website:</b>www.thegreathimalayas.com</Typography>
 <Typography sx={{ mt: 1}}><b>Headquarters:</b></Typography>
 <Typography>Siliguri, Darjeeling District</Typography>
 <Typography>West Bengal - 734001</Typography>
 <Typography>India</Typography>

 <Typography sx={{ mt: 1}}><b>Business Hours:</b></Typography>
 <Typography>Monday - Saturday: 9:00 AM - 7:00 PM IST</Typography>
 <Typography>Sunday: 10:00 AM - 5:00 PM IST</Typography>
 <Typography>24/7 emergency support during active programs</Typography>
        
        <Typography variant="h5" fontWeight={600} sx={{ mt: 6, mb: 2 }}>
    THE GREAT HIMALAYAS PROMISE
        </Typography>
      <Typography sx={{ mt: 1}}>We are committed to delivering exceptional wellness experiences that transform participants physically, mentally, and spiritually. Through authentic practices, pristine natural settings, expert facilitation, and professional logistics, we create the ideal conditions for deep healing and lasting positive change.</Typography>
      <Typography sx={{ mt: 1}}>Your success is our success. Your participants' satisfaction is our mission.</Typography>
      
      </Container>
    </Box>
  );
}
